import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../../store/hooks'
import LoadingContainer from '../ui/loading-container'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, status } = useAppSelector((state) => state.auth)

  if (status === 'loading' || status === 'initial') {
    return <LoadingContainer />
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
